import clsx from 'clsx';

export const FeedbackToast = ({ message, onClose, className }) => {
  return (
    <div
      role="status"
      className={clsx(
        'flex items-center justify-between rounded-[4px] bg-[#10B7FF]/20 p-4 !px-4 px-0 text-white',
        className,
      )}
    >
      <div className="flex items-center gap-2 px-0">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="shrink-0 px-0"
        >
          <g id="Info">
            <circle id="Base" cx="10" cy="10" r="10" fill="#10B7FF" />
            <path
              id="i"
              d="M10.0198 14.868C9.53595 14.868 9.14376 14.4758 9.14376 13.992V8.66C9.14376 8.1762 9.53595 7.784 10.0198 7.784C10.5036 7.784 10.8958 8.1762 10.8958 8.66V13.992C10.8958 14.4758 10.5036 14.868 10.0198 14.868ZM9.29976 6.74C9.09976 6.54 8.99976 6.3 8.99976 6.02C8.99976 5.74 9.09976 5.5 9.29976 5.3C9.49976 5.1 9.73976 5 10.0198 5C10.2998 5 10.5398 5.1 10.7398 5.3C10.9398 5.5 11.0398 5.74 11.0398 6.02C11.0398 6.3 10.9398 6.54 10.7398 6.74C10.5398 6.94 10.2998 7.04 10.0198 7.04C9.73976 7.04 9.49976 6.94 9.29976 6.74Z"
              fill="white"
            />
          </g>
        </svg>
        <p className="m-0 text-[14px] leading-snug text-primary px-0">{message}</p>
      </div>

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Zamknij"
          className="ml-3 flex cursor-pointer items-center justify-center border-none bg-transparent p-0 px-0 text-white transition-opacity hover:opacity-75 focus:outline-none"
        >
          <svg
            className="h-5 w-5 px-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
};
